// utils/date.js
import moment from "moment";

export function dateForInput(value) {
  if (!value) return "";
  return moment(value).isValid()
    ? moment(value).format("YYYY-MM-DD")
    : "";
}
